import React from 'react';
import { SupervisorLucroPage } from '../lucroFiscal/SupervisorLucroPage';

export function modulesHomeSupervisorLucroRealPage() {
  return <SupervisorLucroPage regime="lucro_real" />;
}
